"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitIntoLines = exports.capitalize = exports.randomStr = void 0;
/**
 * Returns a string of random alphanumeric characters.
 */
exports.randomStr = function () {
    return Math.random().toString(36).substr(2);
};
exports.capitalize = function (word) {
    return word.charAt(0).toLocaleUpperCase() + word.slice(1);
};
function splitIntoLines(str, maxCharsPerLine) {
    return str.split(' ').reduce(function (acc, word) {
        var lastLine = acc.length ? acc[acc.length - 1] : '';
        if (lastLine && lastLine.length + word.length + 1 <= maxCharsPerLine)
            acc[acc.length - 1] += ' ' + word;
        else
            acc.push(word);
        return acc;
    }, []);
}
exports.splitIntoLines = splitIntoLines;
//# sourceMappingURL=string.js.map